<template>
  <div class="refuel-detail">
    <div
      class="header"
      :class="classMap[item.cardProductType]"
    >
      <img
        v-if="item.cardProductType === 1"
        src="./assets/sinopec_china_icon.png"
        class="icon"
        alt=""
      >
      <img
        v-else
        src="./assets/sinopec_china_icon.png"
        class="icon"
        alt=""
      >
      <div class="content">
        <div class="title">{{ item.cardProductType === 1 ? '中国石化': '中国石油' }}</div>
        <div class="space">{{ item.cardCode }}</div>
        <div class="space">{{ item.rechargePhone }}</div>
      </div>
    </div>
    <div
      class="card-info"
      :class="{ shadow: item.orderStatus === '01' || item.orderStatus === '02' }"
      style="margin-top: 0.6rem"
    >
      <div class="content-flex">
        <div class="medium">订单状态：</div>
        <div>{{ item.rechargeStatusName }}</div>
      </div>
      <div class="content-flex">
        <div class="left">订单编号</div>
        {{ item.orderNo }}
      </div>
      <div class="content-flex">
        <div class="left">下单时间</div>
        {{ item.createTime }}
      </div>
      <div class="content-flex">
        <div class="left">充值面额</div>
        ￥{{ item.productSkuName }}
      </div>
      <div class="content-flex">
        <div class="left">商品总额</div>
        ￥{{ item.productSkuPrice }}
      </div>
      <div class="content-flex">
        <div class="left">权益优惠</div>
        {{ item.rightDiscount }}元
      </div>
      <div class="content-flex">
        <div class="left">支付金额</div>
        {{ item.customerPay }}
      </div>
    </div>
    <div
      class="card-info"
      v-if="item.refundStatus !== null || item.rechargeStatus === CarLifeOrderStatus.cancel"
    >
      <div class="line public">
        <div class="line-content" />
      </div>
      <div
        class="content-flex"
        style="color: #ff4242;"
      >
        <div class="left">退款总额</div>
        ￥{{ item.refundTotalAmount || 0 }}元
      </div>
      <div class="content-flex">
        <div class="left">权益金额</div>
        ￥{{ item.rightDiscount || 0 }}元
      </div>
      <div
        class="content-flex"
        v-if="item.refundAmount > 0"
      >
        <div class="left">在线支付</div>
        ￥{{ item.refundAmount || 0 }}元
      </div>
      <div
        v-if="item.refundStatus == 1"
        style="font-size: 0.28rem; color: #ff4242; margin-top: 20px"
      >
        支付金额将在1-3个工作日内退回原支付账户
      </div>
    </div>

    <template
      v-if="CarLifeOrderStatus.unpaid === item.rechargeStatus"
    >
      <div class="button-wrapper" />
      <div class="button-wrapper fix">
        <div
          class="cancel"
          @click="cancelClick"
        >取消订单</div>
        <van-button
          class="submit"
          type="info"
          @click="submitClick"
        >立即支付</van-button>
      </div>
    </template>

    <cancel-order
      ref="cancelOrder"
      @cancelClick="getDetail"
    />
  </div>
</template>

<script>
import { handleClipboard } from '@/common/clipboard.js';
import CancelOrder from '@/components/cancel-order.vue';
import Pay from '@/common/weixin.js';
import Utils from '@/common/util.js';
import { carLifeOrderDetail, carLifePayPre } from '@/common/api';
import { CarLifeOrderStatus } from '@/common/constant.js';

const classMap = {
  1: 'sinopec',
  2: 'petrol'
};
export default {
  name: 'RefuelDetail',
  components: {
    CancelOrder
  },
  data() {
    return {
      classMap,
      CarLifeOrderStatus,
      currentPrice: 1000,
      item: {}
    };
  },
  computed: {
    // 支付后的订单
    isRefunded() {
      return this.item.refundAmount && this.item.refundAmount > 0;
    }
  },
  methods: {
    handleClipboard,
    async getDetail() {
      const data = await carLifeOrderDetail({
        orderNo: this.orderNo
      });
      const result = data || {};
      this.item = result;
    },

    cancelClick() {
      this.$refs.cancelOrder.init({
        orderId: this.orderNo
      });
    },
    dateTransform(dateTimestamp) {
      if (dateTimestamp) {
        return Utils.formatTimestamp(dateTimestamp);
      }
      return '';
    },
    // 立即支付的
    submitClick() {
      this.pay(this.orderNo);
    },

    // ---------- 下单流程 start -------------
    async pay(orderNo) {
      const envMap = ['1', '1', '4'];
      // 调起预支付接口成功后
      const prepayRs = await carLifePayPre({
        payType: envMap[this.$browserEnv], // 支付环境
        orderNo
      });
      this.prePayHandle(prepayRs);
    },

    prePayHandle(payload) {
      const _payload = {
        appId: payload.appId,
        timeStamp: payload.timeStamp,
        nonceStr: payload.nonceStr,
        package: payload.packageValue,
        signType: payload.signType,
        paySign: payload.paySign,
        prepayId: payload.prepayId,
        mwebUrl: payload.mwebUrl
      };
      switch (this.$browserEnv) {
        case 0:
          Pay.mpPay(_payload, this.orderNo);
          break;
        case 1:
          Pay.wxPay(_payload, this.prePaySuccess, this.prePayFail);
          break;
        case 2:
          Pay.browserPay(_payload.mwebUrl, this.orderNo);
          break;
      }
    },

    /**
     * 支付成功回调
     */
    prePaySuccess() {
      this.$router.push({
        name: 'resultPage',
        query: {
          orderNo: this.orderNo,
          orderStatus: CarLifeOrderStatus.success,
          orderType: '01'
        }
      });
    }
    // ---------- 下单流程 end ---------------
  },
  created() {
    this.orderNo = this.$route.query.orderNo;
    this.getDetail();
  }
};
</script>

<style lang="scss" scoped>
.refuel-detail {
  background: white;
  width: 7.5rem;
  height: 100vh;
  overflow-y: auto;
  font-size: 0.32rem;
}

.header {
  margin: 0.28rem 0.3rem;
  display: flex;
  flex-direction: row;
  height: 2.84rem;
  width: 6.9rem;
  background-size: cover;

  &.sinopec {
    background-image: url("./assets/sinopec_china_bg.png");
  }

  &.petrol {
    background-image: url("./assets/petrol_china_bg.png");
  }

  .img {
    width: 6.9rem;
    height: 2.84rem;
  }

  .icon {
    width: 0.72rem;
    height: 0.72rem;
    margin-left: 0.34rem;
    margin-top: 0.36rem;
  }

  .content {
    margin-left: 0.26rem;
    display: flex;
    flex-direction: column;
    color: white;
    font-size: 0.3rem;

    .title {
      font-family: PingFangSC-Medium;
      font-size: 0.4rem;
      font-weight: bold;
      margin-top: 0.44rem;
      padding-bottom: 0.32rem;
      line-height: 0.56rem;
    }

    .space {
      padding-bottom: 0.12rem;
      line-height: 0.42rem;
    }
  }
}

.card-info {
  margin: 0.4rem;

  .content-flex {
    width: 100%;
    display: flex;
    flex-direction: row;
    word-break: break-all;
    margin-top: 20px;
    color: #383838;

    .left {
      color: #787878;
      min-width: 1.62rem;
    }

    .medium {
      font-family: PingFangSC-Medium;
      color: #383838;
      min-width: 1.62rem;
    }
  }

  .line {
    &-content {
      height: 1px;
      background-color: #E6E6E6;
    }
  }
}

.shadow {
  box-shadow: inset 0px -1px 0px 0px rgba(230, 230, 230, 1);
}

.button-wrapper {
  display: flex;
  align-items: center;
  height: 1.2rem;
  margin-top: 0.32rem;
  padding: 0 0.4rem;

  &.fix {
    position: fixed;
    left: 0;
    bottom: 0;
  }

  .submit {
    width: 3.15rem;
    height: 0.96rem;
    font-size: 0.32rem;
    background-color: #3399FF;
    border-radius: .16rem;
  }

  .cancel {
    width: 3.15rem;
    height: 0.96rem;
    line-height: 0.96rem;
    text-align: center;
    color: #787878;
    background: #FFFFFF;
    border: 1px solid rgba(120,120,120,1);
    border-radius: .16rem;
    margin-right: .4rem;
  }
}
</style>
